import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Icon, Typography } from '@knockrentals/knock-shared-web-v2';

export const DISTANCE_UNITS = {
  MI: 'miles',
  KM: 'kilometers',
};

export const DISTANCE_UNIT_LABELS = {
  [DISTANCE_UNITS.MI]: 'mi',
  [DISTANCE_UNITS.KM]: 'km',
};

const distanceFormatter = new Intl.NumberFormat('en-US', {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

export const getDistanceText = (distance, unit) => {
  return `${distanceFormatter.format(distance)} ${DISTANCE_UNIT_LABELS[unit]}`;
};

const Distance = ({ distance, unit = DISTANCE_UNITS.MI }) => {
  return (
    <Flex alignItems="center" gap={8}>
      <Icon name="pin-2" size={20} />
      <Typography variant="body2">{getDistanceText(distance, unit)}</Typography>
    </Flex>
  );
};

Distance.propTypes = {
  distance: PropTypes.number,
  unit: PropTypes.oneOf(Object.values(DISTANCE_UNITS)),
};

export default Distance;
